export const updateInvoiceName = (data) => ({
    type: "INVOICEUPDATE",
    payload: data,
})

export const updateInvoiceID = (data) => ({
    type: "INVOICEUPDATEID",
    payload: data,
})